import { render, staticRenderFns } from "./POSStaffPopup.vue?vue&type=template&id=78023805"
import script from "./POSStaffPopup.vue?vue&type=script&lang=js"
export * from "./POSStaffPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports